class jfPolicyRule {
    constructor($scope, $timeout, EventXDao, BinMgrDao, WebhooksDao, JFrogNotifications, XRayUtils, JFrogEventBus,
                xrayLicensesDao, XrayMailDao, $filter) {
        this.eventXDao = EventXDao;
        this.jFrogNotifications = JFrogNotifications;
        this.binMgrDao = BinMgrDao;
        this.webhooksDao = WebhooksDao;
        this.XrayMailDao = XrayMailDao;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.xrayUtils = XRayUtils;
        this.jfrogEventBus = JFrogEventBus;
        this.xrayLicensesDao = xrayLicensesDao;
        this.mailPlaceHolder = "Add Email";
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.severities = this.getMinSeverityTypes();
        this.violations = this.getViolationTypes();
        this.securityCriteriaType = "min_severity";
        this.$scope = $scope;
        this.LicenceCriteriaType = "white-list"
        this.criteriaSwitch = {
            severity: false,
            vulsAge: false,
            cvssRange: false,
            actionViolation: true
        };

        this.actionsDesc = {
            webhooks: `Triggers the configured webhook(s) with the generated violations in a JSON payload`,
            mails: `Sends an email message to all configured recipients with details about the generated violations`,
            custom_severity: `Generates a Violation in Xray with the configured severity`,
            block_download: `Blocks suspected artifacts with violations from being downloaded`,
            unknown_license: `A violation will be generated for artifacts with unknown licenses`,
            fail_build: `Fails the build if build artifacts or dependencies with watch violations are found in your builds`,
            block_release_bundle_distribution: `Blocks Release Bundle distribution to Edge nodes if a violation is found`
        };

    }

    $onInit() {

        this.setSliderOptions();
        this.init();
        this.saveText = "Add Rule";
        if (this.policyMode == 'edit') {
            this.setRuleModalForEdit()
            this.saveText = "Apply"
        }

        if (!this.$scope.$parent.PolicyForm.hasMailConfigured) {
            this.mailPlaceHolder = "No email server is configured";
        }
    }

    getMailData() {
        this.XrayMailDao.get().$promise.then((mail) => {
            this.mail = mail;
            if (mail.host) {
                this.hasMailConfigured = true;
            }
//            this.JFrogEventBus.dispatch(this.EVENTS.FORM_CLEAR_FIELD_VALIDATION, true);
        });
    }
    setRuleModalForEdit() {
        //extract the name from the object
        this.ruleScope.name = this.ruleEditInfo.name;
        //criteria handle

        //Security Criterias Edit handle
        if (this.policyType == 'security') {
            if (!this.ruleEditInfo.criteria.min_severity) {
                this.securityCriteriaType = "cvss_range";
                this.rangeSlider.options.disabled = false;

                if (this.ruleEditInfo.criteria.cvss_range) {
                    this.ruleScope.criteria.cvss_range = {
                        from: this.ruleEditInfo.criteria.cvss_range.from,
                        to: this.ruleEditInfo.criteria.cvss_range.to
                    }
                }
            } else {

                this.ruleScope.criteria.min_severity = _.find(this.severities,
                    {text: this.$filter('capitalizeFirst')(this.ruleEditInfo.criteria.min_severity)});
            }

            if (this.ruleEditInfo.criteria.minVulAge) {
                this.criteriaSwitch.vulsAge = true;
                this.ruleScope.criteria.vulAge = this.ruleEditInfo.criteria.minVulAge;
            }
            //end Security Criterias Edit handle
        } else {
            console.log('Need To Edit!!!', this.ruleEditInfo);
            if (this.ruleEditInfo.criteria.banned_licenses) {
                this.LicenceCriteriaType = 'black-list';
            }
            if (!this.ruleEditInfo.criteria.allow_unknown) {
                this.ruleScope.criteria.allow_unknown = false;
            }
            if (this.ruleEditInfo.actions.custom_severity) {
                let severity = this.$filter('capitalizeFirst')(this.ruleEditInfo.actions.custom_severity);
                this.ruleScope.actions.custom_severity = _.find(this.violations, {text: severity});
            }
        }


        //actions handle
        if (this.ruleEditInfo.actions.mails) {
            this.criteriaSwitch.notifyMail = true;
            this.ruleScope.actions.mails = this.ruleEditInfo.actions.mails;
        }
        if (this.ruleEditInfo.actions.webhooks && this.ruleEditInfo.actions.webhooks.length) {
            this.criteriaSwitch.webhooks = true;
        }
        if (this.ruleEditInfo.actions.fail_build) {
            this.ruleScope.actions.fail_build = true;
        }
        if (this.ruleEditInfo.actions.block_release_bundle_distribution) {
            this.ruleScope.actions.block_release_bundle_distribution = true;
        }

        if (this.ruleEditInfo.actions.block_download && this.ruleEditInfo.actions.block_download.active) {
            this.ruleScope.actions.block_download = {active: true};

            if (this.ruleEditInfo.actions.block_download.unscanned) {
                this.ruleScope.actions.block_download.unscanned = true;
            }
        }

    }

    checkRuleName(retype) {
        if (!retype) {
            return true;
        }
        return !_.includes(retype, '/')
    }

    init() {
        this._getWebhooks();

        if (this.policyType == 'security') {

            this.ruleScope["criteria"] = {
                cvss_range: {
                    from: this.rangeSlider.minValue,
                    to: this.rangeSlider.maxValue
                },
                min_severity: {
                    "text": "unknown",
                    "displayText": "All Severities",
                    "iconClass": "severity unknown",
                    "disabled": false
                }
            }
        } else if (this.policyType == 'license') {
            this.ruleScope["criteria"] = {
                allowed_licenses: this.allowedLic,
                banned_licenses: this.bannedLic
            }

            this._getLicensesList();
        }


        this.ruleScope["actions"] = {
            "custom_severity": {
                "text": "critical",
                "displayText": "High",
                "iconClass": "severity critical",
                "disabled": false
            },
            "webhooks": []
        }
        //TODO : need fetch webhooks for actions

        this.ruleScope.criteria.allow_unknown = true;
    }

    _getWebhooks() {
        this.webhooksDao.get().$promise.then((data) => {
            console.log("Got data", data);
            if (data.length) {
                this.hasWebhooks = true;
            } else {
                this.$timeout(() => {
                    $('jf-policy-rule .actions .jf-multi-dropdown.disabled span').text('No Webhooks are configured')
                }, 300)
            }
            this.webhooks = _.map(data, 'name');

            _.each(this.webhooks, (val, key) => {
                let isSelectedVal = false;

                if (this.policyMode == 'edit' && this.ruleEditInfo.actions.webhooks && this.ruleEditInfo.actions.webhooks.length) {
                    if (this.ruleEditInfo.actions.webhooks.indexOf(val) > -1) {
                        isSelectedVal = true;
                    }
                }

                this.webhooks[key] = {text: val, isSelected: isSelectedVal}

            })

        })
    }


    _getLicensesList() {
        this.xrayLicensesDao.getNames().$promise.then((licenses) => {
            licenses.shift();
            this.constLicenseList = _.cloneDeep(licenses);
            this.bannedLic = [];
            this.allowedLic = [];

            _.each(licenses, (val, key) => {
                let obj = {};

                obj.text = val.name;
                obj.isSelected = false;
                this.bannedLic.push(obj);
                this.allowedLic.push(_.cloneDeep(obj));
            });

            if (this.policyMode == 'edit') {
                this.markSelectedLicenses();
            }
        });
    }

    markSelectedLicenses() {
        console.log('Marking Selected Licenses from ', this.ruleEditInfo);

        if (this.LicenceCriteriaType == 'white-list') {
            _.each(this.allowedLic, (val, key) => {
                if (this.ruleEditInfo.criteria.allowed_licenses && this.ruleEditInfo.criteria.allowed_licenses.indexOf(
                        val.text) > -1) {
                    val.isSelected = true;
                }
            });

        } else {
            _.each(this.bannedLic, (val, key) => {
                if (this.ruleEditInfo.criteria.banned_licenses.indexOf(val.text) > -1) {
                    val.isSelected = true;
                }
            });
        }
    }

    save() {
        if (this.$scope.rulesForm.$valid) {
            this.ruleScope.transformed = this._transformRule();
            this.$close();
        }
    }

    _transformRule() {
        let rulePayload = {}
        rulePayload.name = this.ruleScope.name;
        rulePayload.criteria = this.getRuleCriteria();
        rulePayload.actions = this.getRuleActions();

        return rulePayload;
    }

    getRuleCriteria() {

        let criteria = {};
        if (this.policyType == 'security') {
            if (this.securityCriteriaType == 'min_severity') {
                console.log("assigning ", this.ruleScope);
                criteria.min_severity = this.ruleScope.criteria.min_severity.text;
            } else {
                criteria.cvss_range = this.ruleScope.criteria.cvss_range;
            }
            if (this.criteriaSwitch.vulsAge) {
                criteria.minVulAge = this.ruleScope.criteria.vulAge;
            }

        } else if (this.policyType == 'license') {

            if (this.LicenceCriteriaType == 'white-list') {
                criteria.allowed_licenses = _.map(_.filter(this.allowedLic, (l) => {
                    return l.isSelected
                }), 'text')
            } else {
                criteria.banned_licenses = _.map(_.filter(this.bannedLic, (l) => {
                    return l.isSelected
                }), 'text')
            }
            if (this.ruleScope.criteria) {
                criteria.allow_unknown = this.ruleScope.criteria.allow_unknown;
            }
        }
        return criteria;
    }


    getRuleActions() {
        let actions = {};

        if (this.policyType == 'security') {
            delete this.ruleScope.actions.custom_severity
        } else {
            this.ruleScope.actions.custom_severity = this.ruleScope.actions.custom_severity.text;
        }

        if (this.webhooks) {
            let selectedWebhooks = _.filter(this.webhooks, (w) => {

                return w.isSelected;
            });

            if (selectedWebhooks.length && this.criteriaSwitch.webhooks) {

                this.ruleScope.actions.webhooks = _.map(selectedWebhooks, 'text');
            }
        }

        if (this.ruleScope.actions.mails && this.ruleScope.actions.mails.length == 0) {
            this.criteriaSwitch.notifyMail = false;
        }

        if (!this.criteriaSwitch.notifyMail) {
            delete this.ruleScope.actions.mails;
        }

        if (this.ruleScope.actions.block_download && !this.ruleScope.actions.block_download.active) {
            delete this.ruleScope.actions.block_download;
        }

        return this.ruleScope.actions;

    }

    getMinSeverityTypes() {

        let severityTypes = [
            {
                "text": "Unknown",
                "displayText": "All Severities",
                "iconClass": "severity unknown",
                "disabled": false
            },
            {
                "text": "Low",
                "displayText": "Low",
                "iconClass": "severity minor",
                "disabled": false
            },
            {
                "text": "Medium",
                "displayText": "Medium",
                "iconClass": "severity major",
                "disabled": false
            },
            {
                "text": "High",
                "displayText": "High",
                "iconClass": "severity critical",
                "disabled": false
            }
        ]
        return severityTypes
    }

    getViolationTypes() {

        let violationTypes = [
            {
                "text": "Low",
                "displayText": "Low",
                "iconClass": "severity minor",
                "disabled": false
            },
            {
                "text": "Medium",
                "displayText": "Medium",
                "iconClass": "severity major",
                "disabled": false
            },
            {
                "text": "High",
                "displayText": "High",
                "iconClass": "severity critical",
                "disabled": false
            }
        ]
        return violationTypes
    }

    checkBoxChnage(el) {
        switch (el) {
            // the ordinal 'er' only applies to day of the month
            case 'vulsAge':
                break;
        }
    }

    setSliderOptions() {

        this.rangeSlider = {
            minValue: 0,
            maxValue: 10,
            options: {
                floor: 0,
                ceil: 10,
                step: 0.1,
                precision: 1,
                disabled: true
            }

        };
    }

    securityCriteriaChanged() {
        this.securityCriteriaType == 'min_severity' ? this.rangeSlider.options.disabled = true : this.rangeSlider.options.disabled = false
    }

    getSeverityTemplate($item) {
        return `<div class="icon ${$item.iconClass }"><span> ${$item.displayText} </span></div>`
    }

    saveDisabled() {

        if (this.policyType == 'license') {
            if (!this.ruleScope.criteria.allow_unknown) {
                return false;
            }
            if (this.LicenceCriteriaType == 'white-list') {
                let allowed = _.filter(this.allowedLic, (l) => {
                    return l.isSelected;
                }).length;
                return allowed < 1;
            } else {
                let banned = _.filter(this.bannedLic, (l) => {
                    return l.isSelected;
                }).length;
                return banned < 1;
            }
        }

        return false;

    }


    toggleAction(type) {

        if (type === 'fail_build') {

            this.ruleScope.actions.fail_build === true ? this.ruleScope.actions.fail_build = false : this.ruleScope.actions.fail_build = true;

        }
        if (type === 'block_release_bundle_distribution') {

            this.ruleScope.actions.block_release_bundle_distribution === true ? this.ruleScope.actions.block_release_bundle_distribution = false : this.ruleScope.actions.block_release_bundle_distribution = true;

        }

        if (type === 'block_download') {
            console.log('togelling', this.ruleScope.actions.block_download.active);
            this.ruleScope.actions.block_download.active === false ? this.ruleScope.actions.block_download.unscanned = false : '';
        }
    }

    canUseRuleName(val) {

        if (this.policyMode == 'edit') {
            return true;
        }
        if (val) {
            let hasRules = _.filter(this.$scope.$parent.PolicyForm.rulesGridData, (r) => {

                return r.name.toLowerCase() == val.toLowerCase()
            }).length

            return !hasRules
        } else {
            return false;
        }

    }

}

export function jfPolicyRule() {

    return {
        restrict: 'E',
        scope: {
            $dismiss: '&',
            $close: '&',
            ruleScope: '=',
            policyType: '@',
            policyMode: '@',
            ruleEditInfo: '=?'
        },
        controller: jfPolicyRule,
        controllerAs: 'jfPolicyRule',
        template: require('./jf_policy_rule.html'),
        bindToController: true
    };
}



// WEBPACK FOOTER //
// ./modules/xray/directives/jf_policy_rule/jf_policy_rule.js